export default __webpack_public_path__ + "static/high.77c2892a0af854d1db9bd2e097c00c71.svg";